import { ApplicationConfig, importProvidersFrom, LOCALE_ID, provideZoneChangeDetection, APP_INITIALIZER } from '@angular/core';
import { provideRouter, Router } from '@angular/router';
import { routes } from './app.routes';
import { initializeApp } from './config/initializer/initializer.config';
import { HTTP_INTERCEPTORS, HttpClientModule, provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideTranslation } from './config/i18n/translate-loader.config';
import { TranslateModule } from '@ngx-translate/core';
import { provideAnimations } from '@angular/platform-browser/animations';
import { icons } from './config/icons/icons.config';
import { NZ_ICONS } from 'ng-zorro-antd/icon';
import localeIt from '@angular/common/locales/it';
import { registerLocaleData } from '@angular/common';
import { TokenInterceptor } from './config/interceptor/token.interceptor';
import { it_IT, provideNzI18n } from 'ng-zorro-antd/i18n';
import { provideToastr } from 'ngx-toastr';
import { loadingInterceptor } from './config/interceptor/loading.interceptor';
import { HttpService } from './services/http.service';
import { DataService } from './services/data.service';
import { ConfigService } from './services/env-config.service';
import { NzModalService } from 'ng-zorro-antd/modal';
import { AuthService } from './services/auth.service';
import { keycloakInitService } from './config/keycloak/keycloak-init.config';
import { KeycloakService } from 'keycloak-angular';

registerLocaleData(localeIt);

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    HttpService,
    DataService,
    Router,
    NzModalService,
    KeycloakService,
    provideRouter(routes),
    {
      provide: APP_INITIALIZER,
      useFactory: initializeApp,
      multi: true,
      deps: [HttpService, DataService, ConfigService, Router, AuthService],
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true,
    },
    {
      provide: APP_INITIALIZER,
      useFactory: keycloakInitService,
      multi: true,
      deps: [KeycloakService, ConfigService, HttpService]
    },
    importProvidersFrom(HttpClientModule, TranslateModule.forRoot(provideTranslation())),
    provideHttpClient(withInterceptors([loadingInterceptor])),
    provideAnimations(),
    provideNzI18n(it_IT),
    { provide: NZ_ICONS, useValue: icons },
    { provide: LOCALE_ID, useValue: 'it' },
    provideToastr({
      preventDuplicates: true,
      enableHtml: true,
      closeButton: true,
    }),
  ],
};
